<div class="modal-body p-3 p-md-4">

  <div class="d-flex align-items-start justify-content-between mb-3">
    <div class="overflow-hidden">
      <p class="fs-normal fw-800 color-gray-950 mb-0 text-truncate">{{title()}}</p>
      <app-content-type-badge class="d-inline-block mt-1" [type]="item.type"></app-content-type-badge>
    </div>

    <a class="clickable color-gray-400 ms-2" (click)="modal.dismiss()"
       [ngbTooltip]="'buttons.close'|translate" container="body"><i class="bi bi-x-lg"></i></a>
  </div>

  <ngx-skeleton-loader
    *ngIf="isLoading" count="1" appearance="line"
    [theme]="{height: '280px', 'border-radius': '12px', margin: '0'}"/>

  <ng-container *ngIf="!isLoading">
    <p class="fs-small fw-400 color-gray-400" *ngIf="hasError">{{'students.videos.preview_error'|translate}}</p>

    <!-- A stream that has not finished yet has no recording to play -->
    <div class="upcoming-box text-center p-4" *ngIf="!hasError && isUpcomingStream()">
      <i class="bi bi-broadcast fs-20 color-brand-primary"></i>
      <p class="fs-small fw-800 color-gray-950 mt-2 mb-0">{{'students.videos.stream_not_recorded'|translate}}</p>
      <p class="fs-xsmall fw-400 color-gray-400 mb-0" *ngIf="liveStream?.bePublishedAt">
        {{'students.videos.stream_airs_at'|translate: {date: liveStream?.bePublishedAt | date: 'd MMMM y, HH:mm'} }}
      </p>
    </div>

    <app-static-video-player *ngIf="!hasError && !isUpcomingStream() && playerSrc()"
                             [videoSrc]="playerSrc()"></app-static-video-player>

    <!-- Descriptions are authored as rich text, same as the student's own detail page -->
    <div class="content-description fs-small fw-400 color-gray-400 mt-3" *ngIf="description()"
         [innerHTML]="description()"></div>
  </ng-container>

  <div class="d-flex justify-content-end mt-4">
    <div class="assigned-state d-flex align-items-center gap-2 fs-small fw-800 px-3 py-2" *ngIf="isAssigned">
      <i class="bi bi-check-circle-fill"></i>{{'students.videos.already_assigned'|translate}}
    </div>

    <app-gray-button
      *ngIf="!isAssigned"
      color="primary" [fullWidth]="false" padding="px-3 py-2 gap-1" [weight]="800"
      customClass="d-flex align-items-center fs-small border-8" preIcon="plus"
      [text]="'students.videos.assign'|translate"
      (click)="assign()"></app-gray-button>
  </div>

</div>
